import {
  C_REALESTATE_TYPES_IDS,
  C_REALESTATE_TYPES_PROJECT
} from "@/src-refactor/modules/shared/model/const/property/real-estate-type.const";
import { I_GENERIC_ITEMS } from "@/src-refactor/modules/shared/model/interface/items.interface";
import HCheckArray from "@rf-helper/check-have-value";

const projectFeatureIndicators = {
  name: [
    C_REALESTATE_TYPES_PROJECT.APARTMENT.id,
    C_REALESTATE_TYPES_PROJECT.COMERCIAL_SITE.id,
    C_REALESTATE_TYPES_PROJECT.HOUSE.id,
    C_REALESTATE_TYPES_PROJECT.INDUSTRIAL_SITE.id,
    C_REALESTATE_TYPES_PROJECT.LAND.id
  ],

  bedrooms: [
    C_REALESTATE_TYPES_PROJECT.APARTMENT.id,
    C_REALESTATE_TYPES_PROJECT.HOUSE.id,
    C_REALESTATE_TYPES_PROJECT.INDUSTRIAL_SITE.id
  ],
  bathrooms: [
    C_REALESTATE_TYPES_PROJECT.APARTMENT.id,
    // C_REALESTATE_TYPES_PROJECT.COMERCIAL_SITE.id,
    C_REALESTATE_TYPES_PROJECT.HOUSE.id
    // C_REALESTATE_TYPES_PROJECT.INDUSTRIAL_SITE.id
  ],
  parkingSpots: [
    C_REALESTATE_TYPES_PROJECT.APARTMENT.id,
    C_REALESTATE_TYPES_PROJECT.COMERCIAL_SITE.id,
    C_REALESTATE_TYPES_PROJECT.HOUSE.id,
    C_REALESTATE_TYPES_PROJECT.INDUSTRIAL_SITE.id
  ],
  levelFloor: [
    C_REALESTATE_TYPES_PROJECT.APARTMENT.id,
    C_REALESTATE_TYPES_PROJECT.COMERCIAL_SITE.id
  ],
  meterLand: [
    C_REALESTATE_TYPES_PROJECT.APARTMENT.id,
    C_REALESTATE_TYPES_PROJECT.COMERCIAL_SITE.id,
    C_REALESTATE_TYPES_PROJECT.HOUSE.id,
    C_REALESTATE_TYPES_PROJECT.INDUSTRIAL_SITE.id,
    C_REALESTATE_TYPES_PROJECT.LAND.id
  ],
  meterConstruction: [
    C_REALESTATE_TYPES_PROJECT.APARTMENT.id,
    C_REALESTATE_TYPES_PROJECT.COMERCIAL_SITE.id,
    C_REALESTATE_TYPES_PROJECT.HOUSE.id,
    C_REALESTATE_TYPES_PROJECT.INDUSTRIAL_SITE.id
  ],
  currencySale: [
    C_REALESTATE_TYPES_PROJECT.APARTMENT.id,
    C_REALESTATE_TYPES_PROJECT.COMERCIAL_SITE.id,
    C_REALESTATE_TYPES_PROJECT.HOUSE.id,
    C_REALESTATE_TYPES_PROJECT.INDUSTRIAL_SITE.id,
    C_REALESTATE_TYPES_PROJECT.LAND.id
  ],
  priceSale: [
    C_REALESTATE_TYPES_PROJECT.APARTMENT.id,
    C_REALESTATE_TYPES_PROJECT.COMERCIAL_SITE.id,
    C_REALESTATE_TYPES_PROJECT.HOUSE.id,
    C_REALESTATE_TYPES_PROJECT.INDUSTRIAL_SITE.id,
    C_REALESTATE_TYPES_PROJECT.LAND.id
  ],
  positions: [
    C_REALESTATE_TYPES_PROJECT.APARTMENT.id,
    C_REALESTATE_TYPES_PROJECT.COMERCIAL_SITE.id,
    C_REALESTATE_TYPES_PROJECT.HOUSE.id
  ],
  frames: [
    C_REALESTATE_TYPES_PROJECT.APARTMENT.id,
    C_REALESTATE_TYPES_PROJECT.HOUSE.id,
    C_REALESTATE_TYPES_PROJECT.COMERCIAL_SITE.id,
    C_REALESTATE_TYPES_PROJECT.INDUSTRIAL_SITE.id
  ],
  closets: [
    C_REALESTATE_TYPES_PROJECT.APARTMENT.id,
    C_REALESTATE_TYPES_PROJECT.HOUSE.id,
    C_REALESTATE_TYPES_PROJECT.COMERCIAL_SITE.id,
    C_REALESTATE_TYPES_PROJECT.INDUSTRIAL_SITE.id
  ],
  doors: [
    C_REALESTATE_TYPES_PROJECT.APARTMENT.id,
    C_REALESTATE_TYPES_PROJECT.HOUSE.id,
    C_REALESTATE_TYPES_PROJECT.COMERCIAL_SITE.id,
    C_REALESTATE_TYPES_PROJECT.INDUSTRIAL_SITE.id
  ],
  roof: [
    C_REALESTATE_TYPES_PROJECT.APARTMENT.id,
    C_REALESTATE_TYPES_PROJECT.HOUSE.id,
    C_REALESTATE_TYPES_PROJECT.COMERCIAL_SITE.id,
    C_REALESTATE_TYPES_PROJECT.INDUSTRIAL_SITE.id
  ],
  windows: [
    C_REALESTATE_TYPES_PROJECT.APARTMENT.id,
    C_REALESTATE_TYPES_PROJECT.HOUSE.id,
    C_REALESTATE_TYPES_PROJECT.COMERCIAL_SITE.id,
    C_REALESTATE_TYPES_PROJECT.INDUSTRIAL_SITE.id
  ],
  cabinets: [
    C_REALESTATE_TYPES_PROJECT.APARTMENT.id,
    C_REALESTATE_TYPES_PROJECT.HOUSE.id,
    C_REALESTATE_TYPES_PROJECT.COMERCIAL_SITE.id,
    C_REALESTATE_TYPES_PROJECT.INDUSTRIAL_SITE.id
  ],
  floors: [
    C_REALESTATE_TYPES_PROJECT.APARTMENT.id,
    C_REALESTATE_TYPES_PROJECT.HOUSE.id,
    C_REALESTATE_TYPES_PROJECT.COMERCIAL_SITE.id,
    C_REALESTATE_TYPES_PROJECT.INDUSTRIAL_SITE.id
  ],
  houseType: [
    C_REALESTATE_TYPES_PROJECT.HOUSE.id
    // C_REALESTATE_TYPES_PROJECT.COMERCIAL_SITE.id
  ],
  roofForm: [
    C_REALESTATE_TYPES_PROJECT.HOUSE.id
    // C_REALESTATE_TYPES_PROJECT.COMERCIAL_SITE.id
  ],
  tarea: [C_REALESTATE_TYPES_PROJECT.LAND],
  maintenance: [],
  studio: []
};

const featureIndicators = {
  bedrooms: [
    C_REALESTATE_TYPES_IDS.APARTMENT,
    C_REALESTATE_TYPES_IDS.HOUSE,
    C_REALESTATE_TYPES_IDS.ESTATE,
    C_REALESTATE_TYPES_IDS.TURISTIC,
    C_REALESTATE_TYPES_IDS.HOTEL,
    C_REALESTATE_TYPES_IDS.HOUSE_OR_LAND,
    C_REALESTATE_TYPES_IDS.PROJECT,
    C_REALESTATE_TYPES_IDS.PENTHOUSE,
    C_REALESTATE_TYPES_IDS.BUSINESS

    // C_REALESTATE_TYPES_IDS.OFFICE_SITE
  ],
  bathrooms: [
    C_REALESTATE_TYPES_IDS.APARTMENT,
    C_REALESTATE_TYPES_IDS.HOUSE,
    C_REALESTATE_TYPES_IDS.COMERCIAL_SITE,
    C_REALESTATE_TYPES_IDS.INDUSTRIAL_SITE,
    C_REALESTATE_TYPES_IDS.ESTATE,
    C_REALESTATE_TYPES_IDS.TURISTIC,
    C_REALESTATE_TYPES_IDS.HOTEL,
    C_REALESTATE_TYPES_IDS.HOUSE_OR_LAND,
    C_REALESTATE_TYPES_IDS.PROJECT,
    C_REALESTATE_TYPES_IDS.PENTHOUSE,
    C_REALESTATE_TYPES_IDS.OFFICE_SITE,
    C_REALESTATE_TYPES_IDS.BUSINESS
  ],
  halfBathrooms: [
    C_REALESTATE_TYPES_IDS.APARTMENT,
    C_REALESTATE_TYPES_IDS.HOUSE,
    C_REALESTATE_TYPES_IDS.COMERCIAL_SITE,
    C_REALESTATE_TYPES_IDS.INDUSTRIAL_SITE,
    C_REALESTATE_TYPES_IDS.ESTATE,
    C_REALESTATE_TYPES_IDS.TURISTIC,
    C_REALESTATE_TYPES_IDS.HOTEL,
    C_REALESTATE_TYPES_IDS.HOUSE_OR_LAND,
    C_REALESTATE_TYPES_IDS.PROJECT,
    C_REALESTATE_TYPES_IDS.PENTHOUSE,
    C_REALESTATE_TYPES_IDS.OFFICE_SITE,
    C_REALESTATE_TYPES_IDS.BUSINESS
  ],

  parkingSpots: [
    C_REALESTATE_TYPES_IDS.APARTMENT,
    C_REALESTATE_TYPES_IDS.HOUSE,
    C_REALESTATE_TYPES_IDS.COMERCIAL_SITE,
    C_REALESTATE_TYPES_IDS.INDUSTRIAL_SITE,
    C_REALESTATE_TYPES_IDS.ESTATE,
    C_REALESTATE_TYPES_IDS.BUILDING,
    C_REALESTATE_TYPES_IDS.TURISTIC,
    C_REALESTATE_TYPES_IDS.HOTEL,
    C_REALESTATE_TYPES_IDS.HOUSE_OR_LAND,
    C_REALESTATE_TYPES_IDS.BUILDING_OR_LAND,
    C_REALESTATE_TYPES_IDS.PROJECT,
    C_REALESTATE_TYPES_IDS.PENTHOUSE,
    C_REALESTATE_TYPES_IDS.GAS_STATION,
    C_REALESTATE_TYPES_IDS.OFFICE_SITE,
    C_REALESTATE_TYPES_IDS.BUSINESS
  ],
  pumps: [C_REALESTATE_TYPES_IDS.GAS_STATION],
  levelFloor: [
    C_REALESTATE_TYPES_IDS.APARTMENT,
    C_REALESTATE_TYPES_IDS.COMERCIAL_SITE,
    C_REALESTATE_TYPES_IDS.TURISTIC,
    C_REALESTATE_TYPES_IDS.PROJECT,
    C_REALESTATE_TYPES_IDS.PENTHOUSE,
    C_REALESTATE_TYPES_IDS.OFFICE_SITE,
    C_REALESTATE_TYPES_IDS.BUSINESS
  ],
  totalLevels: [
    C_REALESTATE_TYPES_IDS.HOUSE,
    C_REALESTATE_TYPES_IDS.COMERCIAL_SITE,
    C_REALESTATE_TYPES_IDS.ESTATE,
    C_REALESTATE_TYPES_IDS.BUILDING,
    C_REALESTATE_TYPES_IDS.TURISTIC,
    C_REALESTATE_TYPES_IDS.HOTEL,
    C_REALESTATE_TYPES_IDS.HOUSE_OR_LAND,
    C_REALESTATE_TYPES_IDS.BUILDING_OR_LAND,
    C_REALESTATE_TYPES_IDS.PROJECT,
    C_REALESTATE_TYPES_IDS.PENTHOUSE,
    C_REALESTATE_TYPES_IDS.OFFICE_SITE,
    C_REALESTATE_TYPES_IDS.BUSINESS
  ],

  feature: [
    C_REALESTATE_TYPES_IDS.APARTMENT,
    C_REALESTATE_TYPES_IDS.HOUSE,
    C_REALESTATE_TYPES_IDS.COMERCIAL_SITE,
    C_REALESTATE_TYPES_IDS.INDUSTRIAL_SITE,
    C_REALESTATE_TYPES_IDS.ESTATE,
    C_REALESTATE_TYPES_IDS.BUILDING,
    C_REALESTATE_TYPES_IDS.TURISTIC,
    C_REALESTATE_TYPES_IDS.HOTEL,
    C_REALESTATE_TYPES_IDS.PROJECT,
    C_REALESTATE_TYPES_IDS.PENTHOUSE,
    C_REALESTATE_TYPES_IDS.OFFICE_SITE,
    C_REALESTATE_TYPES_IDS.BUSINESS
  ],
  frames: [
    C_REALESTATE_TYPES_IDS.APARTMENT,
    C_REALESTATE_TYPES_IDS.HOUSE,
    C_REALESTATE_TYPES_IDS.COMERCIAL_SITE,
    C_REALESTATE_TYPES_IDS.ESTATE,
    C_REALESTATE_TYPES_IDS.BUILDING,
    C_REALESTATE_TYPES_IDS.HOTEL,
    C_REALESTATE_TYPES_IDS.BUILDING_OR_LAND,
    C_REALESTATE_TYPES_IDS.PROJECT,
    C_REALESTATE_TYPES_IDS.PENTHOUSE,
    C_REALESTATE_TYPES_IDS.OFFICE_SITE,
    C_REALESTATE_TYPES_IDS.HOUSE_OR_LAND,
    C_REALESTATE_TYPES_IDS.BUSINESS,
    C_REALESTATE_TYPES_IDS.TURISTIC
  ],
  closets: [
    C_REALESTATE_TYPES_IDS.APARTMENT,
    C_REALESTATE_TYPES_IDS.HOUSE,
    C_REALESTATE_TYPES_IDS.COMERCIAL_SITE,
    C_REALESTATE_TYPES_IDS.ESTATE,
    C_REALESTATE_TYPES_IDS.HOTEL,
    C_REALESTATE_TYPES_IDS.PROJECT,
    C_REALESTATE_TYPES_IDS.PENTHOUSE,
    C_REALESTATE_TYPES_IDS.OFFICE_SITE
  ],
  doors: [
    C_REALESTATE_TYPES_IDS.APARTMENT,
    C_REALESTATE_TYPES_IDS.HOUSE,
    C_REALESTATE_TYPES_IDS.COMERCIAL_SITE,
    C_REALESTATE_TYPES_IDS.ESTATE,
    C_REALESTATE_TYPES_IDS.TURISTIC,
    C_REALESTATE_TYPES_IDS.HOTEL,
    C_REALESTATE_TYPES_IDS.BUILDING_OR_LAND,
    C_REALESTATE_TYPES_IDS.PROJECT,
    C_REALESTATE_TYPES_IDS.PENTHOUSE,
    C_REALESTATE_TYPES_IDS.OFFICE_SITE,
    C_REALESTATE_TYPES_IDS.HOUSE_OR_LAND,
    C_REALESTATE_TYPES_IDS.BUILDING,
    C_REALESTATE_TYPES_IDS.BUSINESS
  ],
  roof: [
    C_REALESTATE_TYPES_IDS.APARTMENT,
    C_REALESTATE_TYPES_IDS.HOUSE,
    C_REALESTATE_TYPES_IDS.COMERCIAL_SITE,
    C_REALESTATE_TYPES_IDS.BUILDING,
    C_REALESTATE_TYPES_IDS.TURISTIC,
    C_REALESTATE_TYPES_IDS.HOTEL,
    C_REALESTATE_TYPES_IDS.HOUSE_OR_LAND,
    C_REALESTATE_TYPES_IDS.BUILDING_OR_LAND,
    C_REALESTATE_TYPES_IDS.PROJECT,
    C_REALESTATE_TYPES_IDS.PENTHOUSE,
    C_REALESTATE_TYPES_IDS.GAS_STATION,
    C_REALESTATE_TYPES_IDS.BUSINESS
  ],
  windows: [
    C_REALESTATE_TYPES_IDS.APARTMENT,
    C_REALESTATE_TYPES_IDS.HOUSE,
    C_REALESTATE_TYPES_IDS.COMERCIAL_SITE,
    C_REALESTATE_TYPES_IDS.ESTATE,
    C_REALESTATE_TYPES_IDS.HOTEL,
    C_REALESTATE_TYPES_IDS.PROJECT,
    C_REALESTATE_TYPES_IDS.PENTHOUSE,
    C_REALESTATE_TYPES_IDS.OFFICE_SITE,
    C_REALESTATE_TYPES_IDS.HOTEL
  ],
  cabinets: [
    C_REALESTATE_TYPES_IDS.APARTMENT,
    C_REALESTATE_TYPES_IDS.HOUSE,
    C_REALESTATE_TYPES_IDS.COMERCIAL_SITE,
    C_REALESTATE_TYPES_IDS.ESTATE,
    C_REALESTATE_TYPES_IDS.BUILDING,
    C_REALESTATE_TYPES_IDS.TURISTIC,
    C_REALESTATE_TYPES_IDS.HOTEL,
    C_REALESTATE_TYPES_IDS.BUILDING_OR_LAND,
    C_REALESTATE_TYPES_IDS.PROJECT,
    C_REALESTATE_TYPES_IDS.PENTHOUSE,
    C_REALESTATE_TYPES_IDS.OFFICE_SITE,
    C_REALESTATE_TYPES_IDS.HOUSE_OR_LAND,
    C_REALESTATE_TYPES_IDS.BUSINESS
  ],
  floors: [
    C_REALESTATE_TYPES_IDS.APARTMENT,
    C_REALESTATE_TYPES_IDS.HOUSE,
    C_REALESTATE_TYPES_IDS.COMERCIAL_SITE,
    C_REALESTATE_TYPES_IDS.HOTEL,
    C_REALESTATE_TYPES_IDS.PENTHOUSE,
    C_REALESTATE_TYPES_IDS.OFFICE_SITE
  ],
  houseType: [C_REALESTATE_TYPES_IDS.HOUSE],
  roofForm: [C_REALESTATE_TYPES_IDS.HOUSE],
  tarea: [C_REALESTATE_TYPES_IDS.ESTATE],
  maintenance: [
    C_REALESTATE_TYPES_IDS.APARTMENT,
    C_REALESTATE_TYPES_IDS.HOUSE,
    C_REALESTATE_TYPES_IDS.COMERCIAL_SITE
  ],
  studio: [C_REALESTATE_TYPES_IDS.APARTMENT],
  meterConstruction: [
    C_REALESTATE_TYPES_IDS.HOUSE,
    C_REALESTATE_TYPES_IDS.COMERCIAL_SITE,
    C_REALESTATE_TYPES_IDS.INDUSTRIAL_SITE,
    C_REALESTATE_TYPES_IDS.ESTATE,
    C_REALESTATE_TYPES_IDS.BUSINESS,
    C_REALESTATE_TYPES_IDS.BUILDING,
    C_REALESTATE_TYPES_IDS.TURISTIC,
    C_REALESTATE_TYPES_IDS.HOTEL,
    C_REALESTATE_TYPES_IDS.HOUSE_OR_LAND,
    C_REALESTATE_TYPES_IDS.BUILDING_OR_LAND,
    C_REALESTATE_TYPES_IDS.PROJECT,
    C_REALESTATE_TYPES_IDS.PENTHOUSE,
    C_REALESTATE_TYPES_IDS.GAS_STATION,
    C_REALESTATE_TYPES_IDS.OFFICE_SITE,
    C_REALESTATE_TYPES_IDS.APARTMENT
  ],
  meterLand: [
    C_REALESTATE_TYPES_IDS.HOUSE,
    C_REALESTATE_TYPES_IDS.LAND,
    C_REALESTATE_TYPES_IDS.HOTEL,
    C_REALESTATE_TYPES_IDS.ESTATE,
    C_REALESTATE_TYPES_IDS.BUILDING_OR_LAND,
    C_REALESTATE_TYPES_IDS.PROJECT,
    C_REALESTATE_TYPES_IDS.HOUSE_OR_LAND,
    C_REALESTATE_TYPES_IDS.GAS_STATION,
    C_REALESTATE_TYPES_IDS.INDUSTRIAL_SITE,
    C_REALESTATE_TYPES_IDS.APARTMENT,
    C_REALESTATE_TYPES_IDS.BUILDING
  ],
  maintenancePrice: [
    C_REALESTATE_TYPES_IDS.APARTMENT,
    C_REALESTATE_TYPES_IDS.HOUSE,
    C_REALESTATE_TYPES_IDS.COMERCIAL_SITE
  ],
  positions: [
    C_REALESTATE_TYPES_IDS.APARTMENT,
    C_REALESTATE_TYPES_IDS.HOUSE,
    C_REALESTATE_TYPES_IDS.COMERCIAL_SITE,
    C_REALESTATE_TYPES_IDS.BUSINESS,
    C_REALESTATE_TYPES_IDS.BUILDING,
    C_REALESTATE_TYPES_IDS.TURISTIC,
    C_REALESTATE_TYPES_IDS.HOTEL,
    C_REALESTATE_TYPES_IDS.HOUSE_OR_LAND,
    C_REALESTATE_TYPES_IDS.BUILDING_OR_LAND,
    C_REALESTATE_TYPES_IDS.PROJECT,
    C_REALESTATE_TYPES_IDS.PENTHOUSE,
    C_REALESTATE_TYPES_IDS.GAS_STATION,
    C_REALESTATE_TYPES_IDS.OFFICE_SITE
  ],

  projectName: projectFeatureIndicators.name,
  projectBedrooms: projectFeatureIndicators.bedrooms,
  projectBathrooms: projectFeatureIndicators.bathrooms,
  projectParkingSpots: projectFeatureIndicators.parkingSpots,
  projectLevelFloor: projectFeatureIndicators.levelFloor,
  projectMeterLand: projectFeatureIndicators.meterLand,
  projectMeterConstruction: projectFeatureIndicators.meterConstruction,
  projectCurrencySale: projectFeatureIndicators.currencySale,
  projectPriceSale: projectFeatureIndicators.priceSale,
  projectPositions: projectFeatureIndicators.positions
};

export default featureIndicators;

type environmentKeys = keyof typeof featureIndicators;

export const checkFeatureIndicator = (
  type: number | I_GENERIC_ITEMS[],
  key: environmentKeys
) => {
  if (Array.isArray(type) && HCheckArray(type)) {
    return type.some(x => featureIndicators[key].includes(x.id));
  } else if (typeof type === "number") {
    return featureIndicators[key].includes(type);
  }
  return false;
};

export const checkFeatureIndicatorProject = (
  type: number | I_GENERIC_ITEMS[],
  key: keyof typeof projectFeatureIndicators
) => {
  if (Array.isArray(type) && HCheckArray(type)) {
    return type.some((x: I_GENERIC_ITEMS) =>
      (projectFeatureIndicators[key] as number[]).includes(x.id)
    );
  } else if (typeof type === "number") {
    return (projectFeatureIndicators[key] as number[]).includes(type);
  }
  return false;
};
